var _path, _path2, _path3, _path4, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0965 14.1445H7.07983C6.73483 14.1445 6.45483 13.8645 6.45483 13.5195C6.45483 13.1745 6.73483 12.8945 7.07983 12.8945H13.0965C13.4415 12.8945 13.7215 13.1745 13.7215 13.5195C13.7215 13.8645 13.4415 14.1445 13.0965 14.1445Z",
    fill: "#5D6373"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0965 10.6543H7.07983C6.73483 10.6543 6.45483 10.3743 6.45483 10.0293C6.45483 9.6843 6.73483 9.4043 7.07983 9.4043H13.0965C13.4415 9.4043 13.7215 9.6843 13.7215 10.0293C13.7215 10.3743 13.4415 10.6543 13.0965 10.6543Z",
    fill: "#5D6373"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.37542 7.17383H7.07959C6.73459 7.17383 6.45459 6.89383 6.45459 6.54883C6.45459 6.20383 6.73459 5.92383 7.07959 5.92383H9.37542C9.72042 5.92383 10.0004 6.20383 10.0004 6.54883C10.0004 6.89383 9.72042 7.17383 9.37542 7.17383Z",
    fill: "#5D6373"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_96_285",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 16,
    height: 18
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 1.66602H17.6372V18.2575H2.5V1.66602Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_96_285)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2573 2.91602L6.84976 2.91935C4.90976 2.93102 3.74976 4.13102 3.74976 6.13018V13.7935C3.74976 15.806 4.92059 17.0077 6.87976 17.0077L13.2873 17.0052C15.2273 16.9935 16.3873 15.7918 16.3873 13.7935V6.13018C16.3873 4.11768 15.2173 2.91602 13.2573 2.91602ZM6.88059 18.2577C4.26059 18.2577 2.49976 16.4635 2.49976 13.7935V6.13018C2.49976 3.43602 4.20559 1.68518 6.84559 1.66935L13.2564 1.66602H13.2573C15.8773 1.66602 17.6373 3.46018 17.6373 6.13018V13.7935C17.6373 16.4869 15.9314 18.2385 13.2914 18.2552L6.88059 18.2577Z",
    fill: "#5D6373"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/Document.1a5561aa06eaff307c9757a31cc1754d.svg";
export { ForwardRef as ReactComponent };